import some from 'lodash/some'
import type { TrialAssociation } from '../types/TrialAssociation'
import { isEarlyPhase1, isPhase1 } from './getPhaseFromPhaseList'

export default function isPaidTrial(
  trial: Pick<TrialAssociation, 'healthyVolunteers' | 'phaseList'>,
) {
  return some([
    trial.healthyVolunteers,
    isPhase1(trial.phaseList),
    isEarlyPhase1(trial.phaseList),
  ])
}
